import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { v4 as uuid } from 'uuid';

const TwoDigitsCalendar = ({
  day,
  width,
  height,
  fontWeight,
  className = '',
}) => {
  const theme = useTheme();

  const id = uuid();

  if (day > 31 || day < 1) day = 1;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <filter
          x="-22.6%"
          y="-20.2%"
          width="145.2%"
          height="145.2%"
          filterUnits="objectBoundingBox"
          id={`${id}-b`}
        >
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            stdDeviation="3"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <rect id={`${id}-a`} x="0" y="0" width={width} height={height} rx="3" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id={`${id}-c`} fill="#fff">
          <use xlinkHref={`#${id}-a`} />
        </mask>
        <use fill="#000" filter={`url(#${id}-b)`} xlinkHref={`#${id}-a`} />
        <use fill="#FFF" xlinkHref={`#${id}-a`} />
        <path
          fill="currentColor"
          fillRule="nonzero"
          mask={`url(#${id}-c)`}
          d={`M0 0h${width}v${height / 4.2}H0z`}
        />
        <text
          mask={`url(#${id}-c)`}
          fontFamily="Inter-Bold, Inter, sans-serif"
          fontSize={height - 22}
          fontWeight={theme.fontWeights[fontWeight]}
          fill="#555"
          textAnchor="middle"
        >
          <tspan x="50%" y={height - 10}>
            {day}
          </tspan>
        </text>
      </g>
    </svg>
  );
};

TwoDigitsCalendar.defaultProps = {
  day: 1,
  fontWeight: 1,
};

TwoDigitsCalendar.propTypes = {
  day: PropTypes.number,
  fontWeight: PropTypes.number,
};

export default TwoDigitsCalendar;
